exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colour-viewer[data-v-6935a79e] {\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports
